export const AUTH_KEY_PREFIX = 'CognitoIdentityServiceProvider'

function storage(): Storage | null {
  try {
    return globalThis.localStorage
  } catch {
    return null
  }
}

export function purgeResidualTokens(clientId: string): string[] {
  const store = storage()
  if (!store) return []

  const prefix = `${AUTH_KEY_PREFIX}.${clientId}.`
  const doomed: string[] = []

  try {
    for (let index = 0; index < store.length; index += 1) {
      const key = store.key(index)
      if (key?.startsWith(prefix) === true) doomed.push(key)
    }

    for (const key of doomed) store.removeItem(key)
  } catch {
    return []
  }

  return doomed
}
